<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 col-xl-2 navbar-collapse sidebar">
        <div class="sidebar-header">
          <a class="vik-brand" href="#">
            <img src="@/assets/logo.svg" alt />
          </a>
          <div id="dismissSidebar">
            <svg
              viewBox="0 0 24 24"
              width="24"
              height="24"
              xmlns="http://www.w3.org/2000/svg"
              class="SideNav__closeIcon__56eIa"
              stroke="currentColor"
              tabindex="0"
            >
              <path d="M1 1L23 23M1 23L23 1" />
            </svg>
          </div>
        </div>
        <div class="head-page">
          <div class="page-title">
            <div class="title">
              <h1>Wordlists</h1>
            </div>
          </div>

          <div class="search-group">
            <input
              type="text"
              class="form-control"
              placeholder="filter"
              v-model="wordlistsFilter"
              @input="load(true)"
            />
            <div class="input-icon">
              <i class="vik vik-search"></i>
            </div>
          </div>

          <router-link
            tag="button"
            class="btn btn-primary btn-lg"
            :to="{ name: 'NewWordlist' }"
          >
            <i class="vik vik-plus"></i>Create new
          </router-link>
        </div>
        <div class="card-cont">
          <VuePerfectScrollbar
            class="scroll-area card-list"
            :settings="{ wheelPropagation: false }"
            @ps-y-reach-end="scrollEnd"
          >
            <router-link
              tag="div"
              v-for="wordlist in wordlists"
              :key="wordlist.id"
              :to="{ name: 'SingleWordlist', params: { id: wordlist.id } }"
              v-bind:class="{ active: wordlist.id == $route.params.id }"
              class="card"
            >
              <div class="card-char rounded-circle" style>
                {{ wordlist.list_name[0] }}
              </div>
              <div class="card-body">
                <h5 class="card-title">{{ wordlist.list_name }}</h5>
                <span class="card-info">records: {{ wordlist.total }}</span>
              </div>
            </router-link>
          </VuePerfectScrollbar>
        </div>
      </div>
      <div class="col-md-9 col-lg-10 col-xl-10">
        <div class="content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
<!--

          <p slot="extra">
            <router-link :to="{ name: 'UploadToStorage' }">Create new</router-link>
          </p>
          <a-input placeholder="Filter" class="filter_input" />
          <a-list style="overflow: auto">
            <VuePerfectScrollbar
              class="scroll-area"
              :settings="{ wheelPropagation: false }"
              @ps-y-reach-end="scrollEnd"
            >
              <a-list-item
                class="list-cell"
                v-bind:class="{ 'list-cell-selected': list.id == $route.params.id }"
                v-for="list in lists"
                v-bind:key="list.id"
              >
                <router-link
                  style="display: block;"
                  :to="{ name: 'DictView', params:{id:list.id} }"
                >{{list.list_name}}</router-link>
              </a-list-item>
            </VuePerfectScrollbar>
          </a-list>
        </a-card>
      </a-layout-sider>
      <a-layout>
        <a-layout-content>
          <router-view />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
-->

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { bus } from "@/bus.js";
export default {
  components: { VuePerfectScrollbar },
  watch: {
    $route(to) {
      if (to.params) {
        if (!("id" in this.$route.params) && to.name != "NewWordlist") {
          this.load(true).then(() => {
            if (this.wordlists.length > 0) {
              // redirect
              if (!("hash" in this.$route.params))
                this.$router.replace({
                  name: "SingleWordlist",
                  params: {
                    id: this.wordlists[0].id,
                  },
                });
            } else {
              this.$router.replace({
                name: "NewWordlist",
              });
            }
          });
        }
      }
    },
  },
  data() {
    return {
      wordlists: [],
      wordlistsFilter: "",
      noMore: false,
    };
  },
  async mounted() {
    let that = this;
    this.goToNewest();
    bus.$on("go-to-newest-wordlist", function (data) {
      that.goToNewest();
    });

    bus.$on("refresh-lists", function (data) {
      that.load(true);
    });
  },
  methods: {
    goToNewest() {
      this.load(true).then(() => {
        if (this.wordlists.length > 0) {
          // redirect
          if (!("hash" in this.$route.params))
            this.$router.replace({
              name: "SingleWordlist",
              params: {
                id: this.wordlists[0].id,
              },
            });
        } else {
          this.$router.replace({
            name: "NewWordlist",
          });
        }
      });
    },
    scrollEnd: function () {
      if (!this.noMore) {
        if (this.wordlists.length > 5) this.load(false);
      }
    },
    async load(reset) {
      let that = this;
      that.noMore = false;
      if (reset) this.wordlists = [];
      return new Promise((resolve, reject) => {
        fetch("/api/lists/")
          .then(function (response) {
            if (response.status !== 200) {
              console.log(
                "Looks like there was a problem. Status Code: " +
                  response.status
              );
              return;
            }

            response.json().then(function (data) {
              that.wordlists = data.lists;
              if (data.lists.length != 50) {
                that.noMore = true;
              }
              resolve();
            });
          })
          .catch(function (err) {
            console.log("Fetch Error :-S", err);
            reject();
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Wordlists.vue